import {CSSProperties, useState} from 'react';
import {Button} from '@/components/app/button';
import {Input} from '@/components/ui/input';
import {cn} from '@/lib/utils';
import {Icon} from '../Icon';
import styles from './SearchBar.module.css';
export interface SearchBarProps {
  className?: string;
  inputClassName?: string;
  inputStyle?: CSSProperties;
  onChange: (event: {value: string}) => void;
  placeholder?: string;
  size?: 'sm' | 'lg';
  value: string;
}
export const SearchBar = ({
  className,
  inputClassName,
  inputStyle,
  onChange,
  placeholder,
  size,
  value,
}: SearchBarProps) => {
  const [focused, setFocused] = useState(false);
  return (
    <div
      className={cn(
        styles.searchBar,
        {
          [styles.empty]: !value,
          [styles.focused]: focused,
          [styles.lg]: size === 'lg',
        },
        className,
      )}
    >
      <span aria-hidden className={styles.icon}>
        <Icon icon="search" />
      </span>
      <Input
        className={cn(inputClassName, styles.input)}
        onBlur={() => setFocused(false)}
        onChange={(e) =>
          onChange({
            value: e.target.value,
          })
        }
        onFocus={() => setFocused(true)}
        placeholder={placeholder}
        style={inputStyle}
        value={value}
      />
      {value && (
        <Button
          className={cn(styles.button, 'rounded-full')}
          onClick={() =>
            onChange({
              value: '',
            })
          }
          type={'button'}
          variant="ghost"
          startIcon={<Icon icon={'times'} />}
          aria-label={'Clear search'}
          size="icon"
        />
      )}
    </div>
  );
};
